import { render } from "./CollectionNotify.vue?vue&type=template&id=6a4aaf4a"
import script from "./CollectionNotify.vue?vue&type=script&lang=js"
export * from "./CollectionNotify.vue?vue&type=script&lang=js"

import "./CollectionNotify.vue?vue&type=style&index=0&id=6a4aaf4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__